/**
 * Shared constants for groups actions
 */

export const ITEMS_PER_PAGE = '40';
export const S3_BASE_URL =
    'https://product-groups-production.s3.eu-west-1.amazonaws.com';
